export default __webpack_public_path__ + "static/media/GuyAnimation14.d4efa21b.svg";